<template>
  <div
    :class="row ? 'flex gap-3 overflow-x-auto pb-1' : 'grid gap-3 grid-cols-4'"
  >
    <div
      v-for="design in options"
      :key="design.id"
      :class="row ? 'w-[22%] shrink-0' : ''"
      tag="button"
      show-inactive-hover
      class="flex cursor-pointer flex-col items-stretch justify-center gap-2"
      :is-active="modelValue === design.id"
      :data-test-id="`giftcard-design-${design.id.toLowerCase()}`"
      @click="emit('update:modelValue', design.id)"
    >
      <span
        class="giftcard-design-picker__swatch aspect-square w-full rounded-lg bg-cover bg-center md:aspect-2/1 md:bg-top"
        :class="
          modelValue === design.id
            ? 'border-2 border-teal-500'
            : 'border border-gray-200'
        "
        :style="{
          backgroundImage: design.image ? `url(${design.image})` : undefined,
          backgroundColor: design.color,
        }"
      />
      <span class="text-xs text-center font-medium text-stone-600">
        {{ design.label }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts" generic="T extends string">
import {
  GIFTCARD_DESIGNS,
  type GiftcardDesignOption,
} from '~/utils/giftcardDesigns'

const { t } = useI18n()

const { designs, row = false } = defineProps<{
  modelValue: T
  /** defaults to the built-in personalizer designs */
  designs?: GiftcardDesignOption<T>[]
  /** single horizontally scrolling row instead of the 4-column grid */
  row?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: T]
}>()

const options = computed(
  () =>
    designs ??
    (GIFTCARD_DESIGNS.map((design) => ({
      id: design.id,
      label: t(`personalization.design.${design.id.toLowerCase()}`),
      image: design.buttonBackgroundImage,
    })) as GiftcardDesignOption<T>[])
)
</script>
